import { internalRoutes } from 'environments/common/internal-routes';
import { redirectRoutes_Legacy } from 'environments/common/redirect-routes';

declare type NavigationType = 'Bookings' | 'Invoices' | 'Groups' | 'AgencyCredit' | 'Cac' | 'AccountManagement';

interface NavigationItem {
  title: string;
  customIcon: string;
  url?: string;
}

export const NavigationItems: Record<NavigationType, NavigationItem> = {
  Bookings: {
    title: 'home_component.cards.bookings',
    customIcon: 'ds-icon-plane-right',
    url: internalRoutes.BookingList
  },
  Invoices: {
    title: 'home_component.cards.invoices',
    customIcon: 'ds-icon-newsletter',
    url: redirectRoutes_Legacy.Invoices
  },
  Groups: { title: 'home_component.cards.groups', customIcon: 'ds-icon-three-people' },
  AgencyCredit: {
    title: 'home_component.cards.agency_credit',
    customIcon: 'ds-icon-wallet',
    url: internalRoutes.Bookingscreditflight
  },
  Cac: {
    title: 'home_component.cards.cac',
    customIcon: 'ds-icon-call-center',
    url: 'home_component.cards.cac_url'
  },
  AccountManagement: { title: 'header_component.logged_user_menu.account_management', customIcon: 'ds-icon-settings' }
};
